'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import { WARNING } from 'DesignData/enums/EditorErrorTypes';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { getCodemirrorOptions } from 'DesignData/selectors/codemirror';
import IDECodeMirror from 'DesignEditorsUI/components/shared/IDECodeMirror';
import AnnotationType from 'react-codemirror/enum/AnnotationType';
import Annotation from 'react-codemirror/model/Annotation';
import { getThemeClassFromThemeName } from 'react-codemirror/util/Text';
import CodeEditorError from 'DesignData/models/validation/CodeEditorError';
const disabledCodeMirrorKeyBindings = {
  'Cmd-Z': emptyFunction,
  'Cmd-Y': emptyFunction,
  'Cmd-S': emptyFunction,
  'Ctrl-Z': emptyFunction,
  'Ctrl-Y': emptyFunction,
  'Ctrl-S': emptyFunction
};

const mapStateToProps = state => {
  const {
    theme
  } = getCodemirrorOptions(state);
  return {
    codemirrorTheme: theme
  };
};

class CodeAccordionItem extends PureComponent {
  constructor(...args) {
    super(...args);

    this.refCodemirror = ref => {
      this.codemirror = ref && ref.codemirror;
    };

    this.onOpenChange = e => {
      this.props.onOpenChange(e.target.value);
    };

    this.onCodeChange = ({
      value
    }) => {
      this.props.onCodeChange(value);
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.refresh && !prevProps.refresh && this.props.open) {
      this.codemirror.refresh();
    }
  }

  get codemirrorThemeClassName() {
    const {
      codemirrorTheme
    } = this.props;
    return getThemeClassFromThemeName(codemirrorTheme);
  }

  getAnnotations() {
    const {
      errors
    } = this.props;
    return errors.map(({
      line,
      message,
      type,
      evidence
    }) => {
      return new Annotation({
        message,
        lineNumber: line ? line - 1 : 0,
        type: type === WARNING ? AnnotationType.WARNING : AnnotationType.ERROR,
        evidence
      });
    });
  }

  render() {
    const {
      open,
      mode,
      isReadOnly,
      isProjectsFile,
      asAccordion,
      value,
      sessionId,
      autofocus,
      customWidgetContext
    } = this.props;
    const accordionItemClassName = "code-pane-editor m-all-0 p-all-0";

    const codeEditor = /*#__PURE__*/_jsx(IDECodeMirror, {
      annotations: this.getAnnotations(),
      className: "code-pane-editor",
      sessionId: sessionId,
      readOnly: isReadOnly || isProjectsFile,
      mode: mode,
      onChange: this.onCodeChange,
      value: value,
      enableHublValidation: this.props.enableHublValidation,
      onHublValidation: this.props.onHublValidation,
      onHublValidationFail: this.props.onHublValidationFail,
      extraKeys: disabledCodeMirrorKeyBindings,
      height: "100%",
      width: "100%",
      autofocus: autofocus,
      refCodemirror: this.refCodemirror,
      codemirrorType: mode,
      hublValidationOptions: customWidgetContext
    });

    if (asAccordion) {
      const accordionClassName = classNames('code-pane-accordion', this.codemirrorThemeClassName);

      const title = /*#__PURE__*/_jsx("span", {
        className: "code-pane-accordion-title",
        children: this.props.label
      });

      return /*#__PURE__*/_jsx(UIAccordionItem, {
        animate: false,
        className: accordionClassName,
        contentClassName: accordionItemClassName,
        onOpenChange: this.onOpenChange,
        open: open,
        title: title,
        "data-test-id": `code-pane-${mode}`,
        children: codeEditor
      });
    }

    return codeEditor;
  }

}

CodeAccordionItem.propTypes = {
  asAccordion: PropTypes.bool,
  isReadOnly: PropTypes.bool.isRequired,
  isProjectsFile: PropTypes.bool,
  mode: PropTypes.string.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.instanceOf(CodeEditorError)),
  value: PropTypes.string,
  enableHublValidation: PropTypes.bool,
  onHublValidation: PropTypes.func,
  onHublValidationFail: PropTypes.func,
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  autofocus: PropTypes.bool,
  refresh: PropTypes.bool,
  codemirrorTheme: PropTypes.string.isRequired,
  customWidgetContext: PropTypes.object
};
CodeAccordionItem.defaultProps = {
  asAccordion: true,
  errors: [],
  open: true,
  label: '',
  autofocus: false,
  enableHublValidation: false,
  onHublValidation: emptyFunction,
  onHublValidationFail: emptyFunction
};
export default connect(mapStateToProps)(CodeAccordionItem);